
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052b4","d":"M0 85.333h512V426.67H0z"}}),_c('path',{attrs:{"fill":"#ffda44","d":"M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"}})])
          )
        }
      }
    